import { render, staticRenderFns } from "./WitherHeightSelectComponent.vue?vue&type=template&id=1b80ccee&scoped=true"
import script from "./WitherHeightSelectComponent.vue?vue&type=script&lang=ts"
export * from "./WitherHeightSelectComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b80ccee",
  null
  
)

export default component.exports